import { createStyles, makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(
	theme =>
		createStyles({
			root: {
				height: "100vh",
				position: "relative"
			},
			bodyPage: {
				transform: "translate(0, -50%)",
				width: "100%",
				top: "50%",
				position: "absolute"
			},
			text: {
				color: "#9B9B9B",
				fontSize: 15,
				padding: "5px 0px 40px"
			},
			rootBtn: {
				color: theme.palette.secondary.main,
				borderColor: theme.palette.secondary.main,
				width: 166,
				textTransform: "initial",
				borderRadius: 6
			}
		}),
	{
		name: "NotFoundPage",
		index: 1
	}
);

export default useStyles;
